import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';
import {AgentRole} from 'Users/models/User/AgentUserType';

export class UnvalidatedIAMUserType {
  public readonly key = 'UnvalidatedIAMUserType';
  public readonly agentRole = AgentRole.IAM;

  constructor(
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean,
    public readonly isExternalAdministrator: boolean
  ) {}
}

export class InvalidIAMUserType {
  public readonly key = 'InvalidIAMUserType';
  public readonly agentRole = AgentRole.IAM;

  constructor(
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean,
    public readonly isExternalAdministrator: boolean
  ) {}
}

export class ValidIAMUserType {
  public static create(hasAhlAccess: boolean, hasNewYorkAccess: boolean, isExternalAdministrator: boolean) {
    return hasAhlAccess || hasNewYorkAccess
      ? new ValidIAMUserType(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator)
      : new InvalidIAMUserType(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
  }

  public readonly key = 'ValidIAMUserType';
  public readonly agentRole = AgentRole.IAM;

  constructor(
    public readonly hasAhlAccess: boolean,
    public readonly hasNewYorkAccess: boolean,
    public readonly isExternalAdministrator: boolean
  ) {}
}

export const DefaultIAMUserType = new ValidIAMUserType(true, true, false);

export const changeHasAhlAccess = (hasAhlAccess: boolean) => ({
  hasNewYorkAccess,
  isExternalAdministrator,
}: IAMUserType) => ValidIAMUserType.create(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
export const changeNewYorkAccess = (hasNewYorkAccess: boolean) => ({
  hasAhlAccess,
  isExternalAdministrator,
}: IAMUserType) => ValidIAMUserType.create(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
export const changeIsExternalAdministrator = (isExternalAdministrator: boolean) => ({
  hasAhlAccess,
  hasNewYorkAccess,
}: IAMUserType) => ValidIAMUserType.create(hasAhlAccess, hasNewYorkAccess, isExternalAdministrator);
export type IAMUserType = ValidIAMUserType | InvalidIAMUserType | UnvalidatedIAMUserType;

export type IAMUserTypeOptions<TReturn> = ToMatchOptions<IAMUserType, 'key', TReturn>;

export const matchIAMUserType = <TReturn>(iamUserType: IAMUserType, options: IAMUserTypeOptions<TReturn>): TReturn => {
  switch (iamUserType.key) {
    case 'InvalidIAMUserType':
      return options.InvalidIAMUserType(iamUserType);
    case 'UnvalidatedIAMUserType':
      return options.UnvalidatedIAMUserType(iamUserType);
    case 'ValidIAMUserType':
      return options.ValidIAMUserType(iamUserType);
  }
};
